import type {supplierContactsRouteApi} from "./-route-api";

import {tableURLStateSchema} from "@project/components/data-display/table";
import {z} from "zod";

export const supplierContactsSearchSchema = tableURLStateSchema.extend({
  includeDeleted: z.boolean().optional().default(false),
});
export type SupplierContactsSearch = z.output<typeof supplierContactsSearchSchema>;

export type SupplierContactsNavigateFn = ReturnType<typeof supplierContactsRouteApi.useNavigate>;
